<template>
  <b-card no-body class="questionnaire-info-wrapper border-0 shadow-none questionnaire-item">
    <b-collapse
      id="questionnaire-info"
      visible
      class="phairify-card-body p-0"
      ref="test"
    >
      <study-item
        class="mb-0"
        :questionnaire="questionnaire"
        :study="study"
        :survey-list="this.questionnaireSurvay"
        :show-reset-button="true"
        @reseted-study="$emit('reseted-study')"
        @fill-user-profile="$emit('fill-user-profile', $event)"
      />
    </b-collapse>
  </b-card>
</template>

<script>
import StudyItem from '@/components/study/StudyItem';
import Api from '@/providers/Api';

export default {
  name: 'QuestionnaireItem',
  components: {
    StudyItem,
  },
  props: {
    questionnaire: {
      validator: (prop) => typeof prop === 'object' || prop === null,
      default: null,
    },
  },
  data: function (){
    return {
      questionnaireSurvay : []
    }
  },
  computed: {
    study:  function  () { 
      this.getDetail();           
      return this.questionnaire && this.questionnaire.survey
        ? this.questionnaire.survey
        : null;
    },
    isSurveyStartDate: function () {
      return (
        this.questionnaire &&
        this.questionnaire.survey &&
        this.questionnaire.survey.created
      );
    },
    surveyStartDate: function () {
      return this.isSurveyStartDate
        ? this.$dayjs(this.questionnaire.survey.created).format('MMM D, YYYY')
        : null;
    },
  },
  
  methods: {
    async getDetail(){
      const questionnaireSurvay  = await Api.getQuestionnaireSurvayById(this.questionnaire.id);      
      this.questionnaireSurvay = questionnaireSurvay;
      return questionnaireSurvay;      
    }
  }
};
</script>

<style scoped lang="scss"></style>
